<script>
	import OffsetThresholdWrapperGBLE from './OffsetThresholdWrapperGBLE.svelte';

	export let device;
</script>

<OffsetThresholdWrapperGBLE {device} setting="threshold" type="dark" min={0} max={65535} />
